<template>
  <a-modal :title="title" :width="width" :visible="visible" switchFullscreen @ok="handleSubmit" @cancel="handleCancel"
    :cancelText="$t('关闭')" :okButtonProps="{ class:{'jee-hidden': disabled} }">
    <div class="table-page-search-wrapper">
      <a-form-model layout="vertical" ref="formRef" :model="form" :rules="rules">
        <a-row :gutter="24">
          <a-col :xl="12" :lg="7" :md="8" :sm="24">
            <a-form-model-item :label="$t('合同名称')" prop="contractName">
              <a-input :placeholder="$t('输入合同名称')" v-model="form.contractName" :disabled="disabled"></a-input>
            </a-form-model-item>
          </a-col>
          <!-- <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-model-item :label="$t('合同地址')">
              <a-input :placeholder="$t('输入合同地址')" v-model="form.contractUrl" :disabled="disabled"></a-input>
            </a-form-model-item>
          </a-col> -->
          <a-col :xl="12" :lg="7" :md="8" :sm="24">
            <a-form-model-item :label="$t('开始时间')" prop="beginTime">
              <a-date-picker :placeholder="$t('请选择开始时间')" valueFormat="YYYY-MM-DD" style="width:100%" v-model="form.beginTime"
              :disabled-date="disabledDate"
              @change="onCalendarChange" :disabled="disabled"/>
            </a-form-model-item>
          </a-col>
          <a-col :xl="12" :lg="7" :md="8" :sm="24">
            <a-form-model-item :label="$t('结束时间')" prop="endTime">
              <a-date-picker :placeholder="$t('请选择结束时间')" valueFormat="YYYY-MM-DD" style="width:100%" v-model="form.endTime"
              :disabled-date="disabledDate2"
              @change="onCalendarChange2" :disabled="disabled"/>
            </a-form-model-item>
          </a-col>
          <a-col :xl="24" :lg="7" :md="8" :sm="24">
            <a-form-model-item :label="$t('备注')">
              <a-textarea :placeholder="$t('输入备注')" v-model="form.remark" :disabled="disabled" :rows="4"></a-textarea>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="$t('附件')" prop="contractUrl">
              <JUpload v-model="fileList" @change="uploadChange" :buttonVisible="!disabled"/>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>
  </a-modal>
</template>

<script>
  import moment from 'moment';
  import { httpAction, getAction, postAction,uploadAction } from '@/api/manage'
  import JUpload from '@/components/jeecg/JUpload'
import { add } from 'xe-utils/methods';
import { message } from 'ant-design-vue';
import Vue from 'vue'
import { fromJSON } from 'postcss';
  export default{
    name:'FamilyMembersModal',
    components:{
      JUpload
    },
    data(){
      return{
        title: '',
        width: 800,
        visible: false,
        disabled: false,
        type: 'add',
        form:{},
        disabledCurrentStart:null,
        disabledCurrentEnd:null,
        url:{
          add: "/jeecg-charge/meter/meterUserContract/add",
          edit: "/jeecg-charge/meter/meterUserContract/edit",
          upload: "sys/common/upload",
        },
        fileList: [],
        websocket: null,
        pdfUrl: ''
      }
    },
    computed: {
      // i18n：校验消息使用 computed 以响应语言切换
      rules(){
        return {
          contractName:[
              { required: true, message: this.$t('请输入合同名称')}
          ],
          beginTime:[
              { required: true, message: this.$t('请选择合同开始时间')}
          ],
          endTime:[
              { required: true, message: this.$t('请选择合同结束时间')}
          ],
          contractUrl:[
              { required: true, message: this.$t('请上传合同附件')}
          ]
        }
      }
    },
    methods:{
      uploadChange(file){debugger
        this.form.contractUrl = file;
      },
      init(parent,row,type){
        this.visible = true;
        this.type = type;
        if (type == 'add') {
          this.form = {};
          this.form.userId = parent.userId;
          this.form.userKeyId = parent.id;
          this.title = this.$t('新建用户合同');
          this.disabled = false;
          this.initWebSocket();
          setTimeout(()=>{
            this.onGainIdCard();
          },1000)
        } else if (type == 'edit') {
          this.form = JSON.parse(JSON.stringify(row));
          this.title = this.$t('编辑用户合同');
          this.disabled = false;
          if (this.form.contractUrl == '') {
            this.fileList = [];
          } else {
            this.fileList = [this.form.contractUrl];
          }
        } else {
          this.form = row;
          this.title = this.$t('用户合同详情');
          this.disabled = true;
          if (this.form.contractUrl == '') {
            this.fileList = [];
          } else {
            this.fileList = [this.form.contractUrl];
          }
        }
      },
      handleCancel(){
        this.visible = false;
      },
      handleSubmit(){
        let that = this;
        that.$refs.formRef.validate(valid=>{
          if(valid){
            if(this.type == 'add'){
              postAction(this.url.add,this.form).then(res=>{
                if(res.success){
                  this.$message.success(res.message);
                  this.visible = false;
                  this.$emit('refresh');
                }else{
                  this.$message.error(res.message);
                }
              })
            }else{
              postAction(this.url.edit,this.form).then(res=>{
                if(res.success){
                  this.$message.success(res.message);
                  this.visible = false;
                  this.$emit('refresh');
                }else{
                  this.$message.error(res.message);
                }
              })
            }
          }
        })
      },
      disabledDate(current) {
        return current > moment(this.disabledCurrentEnd) // 大于当前日期不能选
      },
      disabledDate2(current) {
          return current < moment(this.disabledCurrentStart) // 小于当前日期不能选
      },
      onCalendarChange (value, mode) {
          this.disabledCurrentStart = mode
      },
      onCalendarChange2 (value, mode) {
          this.disabledCurrentEnd = mode
      },
      // ---------
      onGainIdCard(){
        let json = {"Type":"5","Method":"star_StartPDFSign","nPort":"0","nBaud":"9600","cBp":"0","szPdfPath":"D:\\test.pdf","nPage":"0","nX":"0","nY":"0","nW":"0","nH":"0","nHandPage":"20","nHandX":"100","nHandY":"400","nVoiceType":"0","szVoice":"语音测试","szTitle":"标题测试","nEndVoiceType":"0","szEndVoice":"谢谢","nOperationType":"1","nTimeout":"60"};
        this.websocketSend(JSON.stringify(json));
      },
      // websocket消息通知开始
      initWebSocket(){
        // WebSocket与普通的请求所用协议有所不同，ws等同于http，wss等同于https
        var userId = this.$store.getters.userInfo.id;
        // var url = window._CONFIG['domianURL'].replace("https://", "wss://").replace("http://", "ws://") + "/websocket/" + userId;
        // var url = 'ws://localhost:19998/'
        var url = 'http://172.16.8.137:19998/'
          
        //update-begin-author:taoyan date:2022-4-22 for:  v2.4.6 的 websocket 服务端，存在性能和安全问题。 #3278
        let token = Vue.ls.get('ACCESS_TOKEN')
          
        this.websocket = new WebSocket(url);
        //update-end-author:taoyan date:2022-4-22 for:  v2.4.6 的 websocket 服务端，存在性能和安全问题。 #3278
        this.websocket.onopen = this.websocketOnopen;
        this.websocket.onerror = this.websocketOnerror;
        this.websocket.onmessage = this.websocketOnmessage;
        this.websocket.onclose = this.websocketOnclose;
      },
      websocketOnopen() {
        console.log("WebSocket消息通知layout连接成功");
        //心跳检测重置
        // this.heartCheck.reset().start();
      },
      websocketOnerror(e) {
        console.log("WebSocket连接发生错误，第%s次", this.wsConnectErrorTime);
          
        this.wsConnectErrorTime = this.wsConnectErrorTime + 1;
        if (this.wsConnectErrorTime > 5) {
          console.log("WebSocket连接错误超过5次，就不再重新连了！");
          this.lockReconnect = true
          return;
        }
        // this.reconnect();
      },
      websocketOnmessage(e) {
        let data = JSON.parse(e.data); //解析json字符串
        console.log("WebSocket消息通知layout收到消息", data);
        // 按照实际需求处理消息（即只推送给含有特定消息类型的用户）
        // if(this.messageType.findIndex(item => item == data.port) == -1) {
        //   return
        // }
        console.log(data);
        debugger
        // 无纸化-PDF电签
        var szPicData = data.szPicData;
        var szPdfData = data.szPdfData;
        // this.picData = "data:image/png; base64,"+szPicData;
        var pdfUrl = atob(szPdfData);
        var pdfNumbers = pdfUrl.length;
        var pdfArray = new Uint8Array(pdfNumbers);
        while( pdfNumbers-- ){
          pdfArray[pdfNumbers] = pdfUrl.charCodeAt(pdfNumbers)
        }
        var file = new File([pdfArray],'合同附件',{type: 'application/pdf'});
        // const blob = new Blob([pdfArray],{type: 'application/pdf'});
        // this.pdfUrl = URL.createObjectURL(blob);
        
        let formData = new FormData();
        formData.append('biz','temp');
        formData.append('file',file);
        uploadAction(this.url.upload,formData).then(res=>{
          if(res.success){
            this.$set(this.form,'contractUrl',res.message);
            this.$set(this,'fileList',[res.message]);
          }
        })
        //心跳检测重置
        //this.heartCheck.reset().start();
      },
      websocketOnclose(e) {
        console.log("connection closed (" + e + ")");
        if (e) {
          console.log("connection closed (" + e.code + ")");
        }
        // this.reconnect();
      },
      websocketSend (text) { // 数据发送
        try {
          this.websocket.send(text);
        } catch (err) {
          console.log("send failed (" + err.code + ")");
        }
      },
    }
  }
</script>

<style>
</style>